import { render, staticRenderFns } from "./December_2022.vue?vue&type=template&id=6cec37fa&scoped=true&"
import script from "./December_2022.vue?vue&type=script&lang=js&"
export * from "./December_2022.vue?vue&type=script&lang=js&"
import style0 from "./December_2022.vue?vue&type=style&index=0&id=6cec37fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cec37fa",
  null
  
)

export default component.exports